import { createSlice } from "@reduxjs/toolkit";
// api
import { checkGuideAPI, updateGuideAPI } from "src/api";

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    error: null,
    // ----------------------------------
    guide: undefined,
    //
    isRewardUser: undefined
};

const slice = createSlice({
    name: "user",
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        hasError(state, action) {
            state.isLoading = false;
            //
            state.error = action.payload;
        },

        clearError(state) {
            state.error = null;
        },

        // UPDATE GUIDE
        updateGuideSuccess(state, action) {
            state.isLoading = false;
            //
            state.guide = action.payload;
        },

        // CHECK IS REWARD USER
        checkRewardSuccess(state, action) {
            state.isLoading = false;
            //
            state.isRewardUser = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    checkRewardSuccess,
    clearError
} = slice.actions;

// ----------------------------------------------------------------------


// ----------------------------------------------------------------------

export function checkGuide() {
    return async (dispatch) => {
        try {
            const { status, data } = await checkGuideAPI();

            if (status === 200) {
                dispatch(slice.actions.updateGuideSuccess(data?.data ?? 0));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

// ----------------------------------------------------------------------

export function updateGuide(progress) {
    return async (dispatch) => {
        try {
            const { status } = await updateGuideAPI({ progress });

            if (status === 200) {
                dispatch(slice.actions.updateGuideSuccess(progress || 0));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}
